module.exports = __webpack_public_path__ + "img/logo.c475726b.svg";